module.exports = __webpack_public_path__ + "img/56.03a97c1f.jpg";